import AddCommentOutlinedIcon from "@mui/icons-material/AddCommentOutlined";
import HistoryIcon from "@mui/icons-material/History";
import { Box } from "@mui/material";
import { CustomButton } from "../../../components/customButton/CustomButton";
import { PopoverModal } from "../../../components/popoverModal/PopoverModal";
import { useDialogs } from "../../../hooks/useDialogs";
import { AddCommentDialog } from "./AddCommentDialog";
import { CommentHistoryDialog } from "./CommentHistoryDialog";
import { useCreateOrUpdateOrdenPedido } from "../hooks/useCreateOrUpdateOrdenPedido";
import { ConfirmCancelDialog } from "./ConfirmCancelDialog";

export const EnvioActionsButtons = ({
  idOrdenPedido,
  idEvaluacion,
  formValues,
  insumosRows,
  isActualizarStockRequired,
  datosDetalle,
  showBum,
  showJustificacionCondicional,
  bloqueoClienteSAP,
  initialEnvioEstado
}) => {
  const { dialogs, handleOpenDialog, handleCloseDialog } = useDialogs({
    addComment: false,
    showCommentHistory: false,
    confirmCancel: false
  });

  const handleOpenAddCommentCallback = () => {
    handleOpenDialog("addComment");
    handleCloseDialog("showCommentHistory");
    handleCloseDialog("confirmCancel");
  };

  const handleCreateOrUpdateOrdenPedido2 = () => {
    if (formValues.idEstadoEnvio == 3) {
      handleCloseDialog("addComment");
      handleCloseDialog("showCommentHistory");
      handleOpenDialog("confirmCancel");
    } else {
      handleCreateOrUpdateOrdenPedido();
    }    
  };

  const { handleCreateOrUpdateOrdenPedido, loading } =
    useCreateOrUpdateOrdenPedido({
      idOrdenPedido,
      idEvaluacion,
      formValues,
      insumosRows,
      isActualizarStockRequired,
      datosDetalle,
      showBum,
      showJustificacionCondicional,
      bloqueoClienteSAP,
      initialEnvioEstado
    });

  return (
    <>
      <Box display="flex" gap="10px">
        <PopoverModal asButton label="Comentarios">
          <div className="popover-modal-content">
            <div
              aria-hidden='true'
              onClick={() => handleOpenDialog("addComment")}
              className="item-option clickable-option"
            >
              <AddCommentOutlinedIcon className="edit-icon" />
              <span className="toggle-action">Nuevo</span>
            </div>
            <div
              aria-hidden='true'
              onClick={() => handleOpenDialog("showCommentHistory")}
              className="item-option clickable-option"
            >
              <HistoryIcon className="edit-icon" />
              <span className="toggle-action">Historial</span>
            </div>
          </div>
        </PopoverModal>
        {datosDetalle?.allowedWrite && <CustomButton
          label="Guardar"
          onClick={handleCreateOrUpdateOrdenPedido2}
          isLoading={loading}
          variant="contained"
          disabled={!datosDetalle?.allowedWrite}
        />}
      </Box>

      {dialogs.addComment && (
        <AddCommentDialog
          open={dialogs.addComment}
          idPaciente={parseInt(formValues.hC)}
          idDelegacion={formValues.idDelegacion}
          handleCloseDialog={() => handleCloseDialog("addComment")}
        />
      )}

      {dialogs.showCommentHistory && (
        <CommentHistoryDialog
          open={dialogs.showCommentHistory}
          idPaciente={parseInt(formValues.hC)}
          idDelegacion={formValues.idDelegacion}
          handleCloseDialog={() => handleCloseDialog("showCommentHistory")}
          handleOpenAddCommentDialog={handleOpenAddCommentCallback}
        />
      )}

      {dialogs.confirmCancel && (
        <ConfirmCancelDialog
          open={dialogs.confirmCancel}
          loading={loading}
          handleCreateOrUpdateOrdenPedido={handleCreateOrUpdateOrdenPedido}
          handleCloseDialog={() => handleCloseDialog("confirmCancel")}
        />
      )}
    </>
  );
};
